module.exports = __webpack_public_path__ + "img/da_left2.a2700cca.png";